import classNames from 'classnames';
import { keys } from 'lodash/fp';
import PropTypes from 'prop-types';
import * as React from 'react';
import { forwardRef, Ref } from 'react';
import { EventTrackingProps, trackEvent } from '../../services/Tracking';

export const KINDS_CLASSMAP = {
    DEFAULT: 'button',
    PRIMARY: 'button save',
    PRIMARY_ALTERNATE: 'button done',
    WARNING: 'button warning',
    TRANSPARENT: 'button button--transparent',
    LINK: 'link-style',
    PLAIN: '',
};

export const KINDS = keys(KINDS_CLASSMAP) as ButtonKind[];

export type ButtonKind = keyof typeof KINDS_CLASSMAP;

export type ButtonProps = {
    kind?: ButtonKind;
    isSmall?: boolean;
    eventTracking?: EventTrackingProps;
    testId?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const Button = forwardRef(
    (
        {
            kind = 'DEFAULT',
            isSmall = false,
            eventTracking,
            className,
            type = 'button',
            testId,
            ...passedProps
        }: ButtonProps,
        ref?: Ref<HTMLButtonElement>
    ) => {
        const cN = classNames({ small: isSmall }, KINDS_CLASSMAP[kind], className);
        return (
            <button
                {...passedProps}
                type={type}
                className={cN}
                ref={ref}
                onClick={e => {
                    if (eventTracking) {
                        trackEvent(eventTracking);
                    }
                    passedProps.onClick?.(e);
                }}
                data-testid={testId}
            />
        );
    }
);

export default Button;

export const buttonPropTypes = {
    kind: PropTypes.oneOf(KINDS),
    disabled: PropTypes.bool,
    isSmall: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string,
    type: PropTypes.oneOf<'button' | 'submit' | 'reset'>(['button', 'submit', 'reset']),
    children: PropTypes.node,
    'aria-label': PropTypes.string,
    'data-intercom-target': PropTypes.string,
};

(Button as any).propTypes = buttonPropTypes;
